"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDateFormatString = void 0;
var date_format_options_1 = require("../../../../types/functions/date-format-options");
/**
 * Returns the format string for the date format request.
 */
function getDateFormatString(options) {
    var formats = options.formats, format = options.format;
    switch (format) {
        case date_format_options_1.DateFormat.ISO:
            return formats.iso;
        case date_format_options_1.DateFormat.DateLong:
            return formats.dateLong;
        case date_format_options_1.DateFormat.DateShort:
            return formats.dateShort;
        case date_format_options_1.DateFormat.DateDefault:
            return formats.dateDefault;
        case date_format_options_1.DateFormat.TimeLong:
            return formats.timeLong;
        case date_format_options_1.DateFormat.TimeShort:
            return formats.timeShort;
        case date_format_options_1.DateFormat.TimeDefault:
            return formats.timeDefault;
        default:
            return format;
    }
}
exports.getDateFormatString = getDateFormatString;
//# sourceMappingURL=get-date-format-string.js.map